import * as React from 'react';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';

interface CircularProgressBarProps {
  color?: 'primary' | 'secondary' | 'success' | 'inherit' | 'error' | 'info' | 'warning'
}

const CircularProgressBar = (props: CircularProgressBarProps) => {
  return (
    <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
      <CircularProgress color={props.color || 'primary'} />
    </Stack>
  );
}

export default CircularProgressBar;
